import { ThemeUICSSObject } from 'theme-ui';

export const permissions: ThemeUICSSObject = {
  '.uploader__permissions_selection': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'end',
    gap: 4,
    div: {
      width: '100%',
    },
    select: {
      width: '100%',
    },
    button: {
      width: '70%',
    },
    span: {
      fontWeight: 'normal',
    },
  },

  '.permissions__list': {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    ul: {
      borderRadius: 'default',
      border: '1px solid',
      borderColor: 'palette.border.field',
      background: 'palette.background.paper',
    },
  },
};
